import React from 'react';
import { Button, Modal } from '../ui';
import SingleClaimConfirmModalWrapper from './ConfirmLeaveModal.style';

/**
 * This component renders a confirmation Modal for leaving a form or page with unsaved changes.
 * @param {String} cancelButtonLabel - The label for the cancel button.
 * @param {String} message - The message to be displayed in the modal.
 * @param {Function} onCancelButtonClick - The function to be called when the cancel button is clicked.
 * @param {Function} onOkButtonClick - The function to be called when the ok button is clicked.
 * @param {String} okButtonLabel - The label for the ok button.
 * @param {String} title - The title of the modal.
 * @param {Number} width - The width of the modal.
 */
const ConfirmLeaveModal = ({
  cancelButtonLabel = 'Abbrechen',
  message = 'Ihre Änderungen wurden noch nicht gespeichert. Wollen Sie diese verwerfen?',
  onCancelButtonClick,
  onOkButtonClick,
  okButtonLabel = 'Änderungen verwerfen',
  title = 'Ungespeicherte Änderungen',
  width = 600,
  ...props
}) => (
  <Modal
    title={title}
    mask={{ closable: true }}
    onCancel={onCancelButtonClick}
    width={width}
    className="centered-modal"
    centered
    footer={
      <SingleClaimConfirmModalWrapper>
        <Button type="secondary" onClick={onCancelButtonClick}>
          {cancelButtonLabel}
        </Button>
        <Button type="primary" onClick={onOkButtonClick}>
          {okButtonLabel}
        </Button>
      </SingleClaimConfirmModalWrapper>
    }
    {...props}
  >
    {message}
  </Modal>
);

export default ConfirmLeaveModal;
